import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.16.0_@parcel+watcher@2.5.1_@types+node@22.13.10_db0@0.3.1_ioredis@5.6.0_lightningcss@1_msv2i33z6sgm2yn2g3vumvkz7m/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "smooth"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}